import { DateTime } from 'luxon';

export class CustomerBillInfo {
    public readonly year: string;

    public readonly month: string;

    constructor(json: Record<string, any>) {
        this.year = json.year;
        this.month = json.month;
    }
}

export class CustomerBill {
    public readonly invoiceNumber: string;

    public readonly invoiceDate: DateTime;

    public readonly amount: number;

    public readonly resourceUrl: string;

    constructor(json: Record<string, any>) {
        this.invoiceNumber = json.invoiceNumber;
        this.invoiceDate = DateTime.fromISO(json.invoiceDate);
        this.amount = json.amount;
        this.resourceUrl = json.resourceUrl;
    }
}
